import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { fireErrorAnalytics } from '@atlassian/error-handling';
export var HubErrorBoundary = function HubErrorBoundary(_ref) {
  var children = _ref.children,
    packageName = _ref.packageName,
    id = _ref.id,
    fallback = _ref.fallback;
  var onError = function onError(error) {
    fireErrorAnalytics({
      error: error,
      meta: {
        id: id,
        packageName: packageName
      }
    });
  };
  return /*#__PURE__*/React.createElement(ErrorBoundary, {
    onError: onError,
    fallback: fallback
  }, children);
};